import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import Animation from './js/animations.js'
import ContactForm from './components/contact-form.js';
import Instagram from './components/Instagram.js';
import 'whatwg-fetch'

let React = require('react');
let ReactDOM = require('react-dom');

function validateEmail(email) {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function scrollIt(destination, duration = 500, easing = 'easeInQuad', callback) {

    const easings = {
        linear(t) {
            return t;
        },
        easeInQuad(t) {
            return t * t;
        },
        easeOutQuad(t) {
            return t * (2 - t);
        },
        easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic(t) {
            return t * t * t;
        },
        easeOutCubic(t) {
            return (--t) * t * t + 1;
        },
        easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart(t) {
            return t * t * t * t;
        },
        easeOutQuart(t) {
            return 1 - (--t) * t * t * t;
        },
        easeInOutQuart(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
        },
        easeInQuint(t) {
            return t * t * t * t * t;
        },
        easeOutQuint(t) {
            return 1 + (--t) * t * t * t * t;
        },
        easeInOutQuint(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
        }
    };

    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
    let destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop - 130;
    if (destinationOffset <= 0) {
        destinationOffset = 0;
    }
    const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

    if ('requestAnimationFrame' in window === false) {
        window.scroll(0, destinationOffsetToScroll);
        if (callback) {
            callback();
        }
        return;
    }

    function scroll() {
        const now = 'now' in window.performance ? performance.now() : new Date().getTime();
        const time = Math.min(1, ((now - startTime) / duration));
        const timeFunction = easings[easing](time);
        window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));
        if (window.pageYOffset === destinationOffsetToScroll) {
            if (callback) {
                callback();
            }
            return;
        }

        requestAnimationFrame(scroll);
    }

    scroll();
}


function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) +
        ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
}

document.addEventListener("DOMContentLoaded", function (event) {
    let doc = document;
    let width = doc.documentElement.clientWidth;


    let contactForme = document.getElementById('contact-form');
    if (contactForme) {
        ReactDOM.render(<ContactForm lang={JSON.parse(contactForme.getAttribute('data-lang'))} />, contactForme);
    }

    let instagram = doc.getElementById('instagram-feed');
    if (instagram) {
        ReactDOM.render(<Instagram lang={JSON.parse(instagram.getAttribute('data-lang'))} />, instagram);
    }


    let hamburger = doc.querySelector('header .hamburger');
    let header = doc.querySelector('header');
    hamburger.addEventListener('click', () => {
        header.classList.toggle('open-menu');
    });

    let openModalButtons = doc.querySelectorAll('.open-modal');
    for (let i = 0; i < openModalButtons.length; i++) {
        let button = openModalButtons[i];
        button.addEventListener('click', (e) => {
            let data = new FormData();
            let type = button.getAttribute('data-modal');

            data.append('t', 'modal');
            data.append('type', type);

            window.fetch('/ajax/ajax.php', {
                'method': 'POST',
                body: data
            }).then(result => {
                return result.text();
            }).then(data => {

                doc.querySelector('body,html').style.overflow = 'hidden';
                doc.querySelector('.modal-box .modal-wrap').innerHTML = data;
                doc.querySelector('.modal-box').classList.add('open');

                doc.querySelector('.close-modal').addEventListener('click', () => {
                    doc.querySelector('.modal-box').classList.remove('open');
                    doc.querySelector('body,html').style.overflow = 'auto';
                });
                let contactForme = document.getElementById('contact-form');
                if (contactForme) {
                    ReactDOM.render(<ContactForm
                        lang={JSON.parse(contactForme.getAttribute('data-lang'))} />, contactForme);
                }
            });
            e.preventDefault();
        })
    }

    let sliderPartners = doc.querySelector('.slider-partners');
    let sliderPartnersWrap = doc.querySelector('.slider-partners .wrap');
    let imgWrap = doc.querySelectorAll('.slider-partners .wrap .img-wrap');
    if (imgWrap.length > 0) {

        let imgWrapWidth = sliderPartners.offsetWidth / 5;
        sliderPartnersWrap.style.width = imgWrapWidth * imgWrap.length + 'px';

        if (width < 768) {
            imgWrapWidth = sliderPartners.offsetWidth / 2;
            sliderPartnersWrap.style.width = imgWrapWidth * imgWrap.length + 'px';
        } else if (width < 991) {
            imgWrapWidth = sliderPartners.offsetWidth / 3;
            sliderPartnersWrap.style.width = imgWrapWidth * imgWrap.length + 'px';
        }

        for (let i = 0; i < imgWrap.length; i++) {
            let img = imgWrap[i];
            img.style.flex = '0 0 ' + imgWrapWidth + 'px';
        }
        let count = 1;
        sliderPartnersWrap.classList.remove('no-transition');
        sliderPartnersWrap.style.marginLeft = imgWrapWidth * count * -1 + 'px';
        count++;
        setInterval(() => {
            let width = doc.documentElement.clientWidth;
            let sliderPartners = doc.querySelector('.slider-partners');
            let imgWrapWidth = sliderPartners.offsetWidth / 5;

            if (width < 768) {
                imgWrapWidth = sliderPartners.offsetWidth / 2;
            } else if (width < 991) {
                imgWrapWidth = sliderPartners.offsetWidth / 3;
            }


            if (count === imgWrap.length - 4) {
                sliderPartnersWrap.classList.add('no-transition');
                sliderPartnersWrap.style.marginLeft = 0 + 'px';
                count = 0;
            } else {
                sliderPartnersWrap.classList.remove('no-transition');
                sliderPartnersWrap.style.marginLeft = imgWrapWidth * count * -1 + 'px';
            }
            count++;
        }, 5000);

    }
});


window.addEventListener('resize', function (event) {
    let doc = document;
    let width = doc.documentElement.clientWidth;

    let imgWrap = doc.querySelectorAll('.slider-partners .wrap .img-wrap');
    if (imgWrap.length > 0) {
        let sliderPartners = doc.querySelector('.slider-partners');
        let sliderPartnersWrap = doc.querySelector('.slider-partners .wrap');
        let imgWrapWidth = sliderPartners.offsetWidth / 5;
        if (width < 768) {
            imgWrapWidth = sliderPartners.offsetWidth / 2;
        } else if (width < 991) {
            imgWrapWidth = sliderPartners.offsetWidth / 3;
        }
        sliderPartnersWrap.style.width = imgWrapWidth * imgWrap.length + 'px';
        for (let i = 0; i < imgWrap.length; i++) {
            let img = imgWrap[i];
            img.style.flex = '0 0 ' + imgWrapWidth + 'px';
        }
    }
});
